import _createClass from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
export var ExternalInteractorBase = /*#__PURE__*/_createClass(function ExternalInteractorBase(container) {
  _classCallCheck(this, ExternalInteractorBase);
  this.container = container;
  this.type = 0;
});